import { UserMe } from "../interfaces/user-me.interface";

export const initialState: UserMe = {
  fullName: "",
  email: "",
  recertification: {
    remainingDays: 0,
    limitDate: "",
    status: "ATTESTED",
  },
  revision: {
    logonsTotal: 0,
  },
  virtualTour: {
    enabled: false,
  },
  channel: {
    channelCode: 4,
    channelDescription: "PME",
  },
};
